// Generated by Melange

import * as JsxRuntime from "react/jsx-runtime";

function LegalConsentPage(Props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h3", {
        children: "Согласие на сбор персональных данных",
        className: "h4 lg:h3 text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "В соответствии с Законом Республики Казахстан от «О персональных данных и их защите» от 21 мая 2013 года (далее – «Закон»).",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "Я даю свое согласие на сбор и обработку моих персональных данных ТОО «Бухта», БИН: 140840021970 (далее – «Бухта»), а также третьим лицам, связанным, как в настоящее время, так и в будущем времени с Бухта какими-либо правоотношениями, направленными на получение, хранение, использование и распространение, трансграничную передачу моих персональных данных, а также на их изменение и (или) дополнение способом, не противоречащих законодательству Республики Казахстан, зафиксированных на электронном, бумажном и (или) ином материальном носителе, включая, но, не ограничиваясь:",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "1. Данные Пользователя:",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ul", {
        children: [
          JsxRuntime.jsx("li", {
            children: "период, за который необходимо рассчитать налоговую отчетность;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "вид декларации;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "категория налогоплательщика;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "наличие контрольно-кассовой машины;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "наличие трехкомпонентной интегрированной системы;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "адрес регистрации, адрес местожительства, адрес осуществления деятельности;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "код органа государственных доходов по месту жительства;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "код органа государственных доходов по регистрации;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "сведения об открытых банковских счетах;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "доход;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "доход от применения трехкомпонентной интегрированной системы (согласно пункту 72-1 статьи. 1 НК РК) (ТИС);",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "ИИН, фамилия, имя, отчество, дата рождения, резидентство;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "email, телефон;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "доход для исчисления социальных отчислений, доход для исчисления обязательных пенсионных взносов;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "дата постановки на регистрационный учет Пользователя в качестве индивидуального предпринимателя;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "дата регистрации юридического лица;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "социальный статус;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "численность работников.",
            className: "paragraph text-black-landing"
          })
        ],
        className: "list-disc list-inside"
      }),
      JsxRuntime.jsx("p", {
        children: "2. Данные о каждом работнике Пользователя:",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ul", {
        children: [
          JsxRuntime.jsx("li", {
            children: "ИИН, фамилия, имя, отчество (при наличии), дата рождения, резидентство;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "дата заключения трудового договора, дата расторжения или прекращения трудового договора;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "социальный статус;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "информация по вычетам;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "заработная плата работника;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "трудовой договор, заключенный между Пользователем и работником;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "метод расчета заработной платы работника;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "информация о премиях, выплаченных работнику;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "информация о штрафах;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "доход;",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "информация о пенсионных, социальных, отчислениях, отчислениях на медицинское страхование, взносах на медицинское страхование;",
            className: "paragraph text-black-landing"
          })
        ],
        className: "list-disc list-inside"
      }),
      JsxRuntime.jsx("p", {
        children: "И, при необходимости, другие данные, необходимые для расчета налоговой формы и сервисов Бухта.",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "Бухта на основании полученных от Пользователя данных проводит расчет и заполнение налоговой формы за период, указанный Пользователем и предоставляет ему ответ в виде визуального представления налоговой формы.\nДля подготовки документов Пользователь через интерфейс, вводит данные необходимые для подготовки документа, а именно, суммы, реквизиты контрагента (-ов), данные о товарах и услугах. В ответ Бухта предоставляет визуальное представление запрашиваемого документа.\n",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "Я даю согласие на получение Бухта всех указанных персональных данных от всех и любых государственных органах Казахстана, включая, но не ограничиваясь государственными базами как Государственный сервис контроля доступа к персональным данным, согласно Закону о персональных данных, Центр обмена идентификационными данными, согласно Постановлению Правления Национального Банка Республики Казахстан от 31 августа 2016 года, и в любых других базах государственных органов.",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "Я обязуюсь в период действия Договора присоединения и Условий оказания информационных услуг и денежных выплат письменно сообщать Бухта о любых изменениях и (или) дополнениях моих (обо мне) персональных данных, с представлением Бухта соответствующих подтверждающих документов.",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "Я подтверждаю, что:",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "– настоящее согласие распространяется на все отношения с Бухта и действует как в период действия Договора присоединения и Условий оказания информационных услуг и в течение иных сроков, установленных законодательством Республики Казахстан, необходимых для надлежащего исполнения Бухта прав и обязанностей, возложенных на него законодательством Республики Казахстан;",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "– настоящим согласием Бухта предоставлено право самостоятельно определять условия доступа третьих лиц к моим персональным данным;",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "– при сборе, обработке Бухта моих персональных данных не требуется уведомления меня об этом;",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "– в случае наличия неисполненного обязательства, а также если это противоречит законам Республики Казахстан я не могу отозвать согласие на сбор и обработку персональных данных;",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "– сбор и обработка персональных данных может осуществляться без моего согласия об этом, в случаях, установленных законами Республики Казахстан",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "– каких-либо претензий к Бухта касательно сбора и обработки моих (обо мне) персональных данных в дальнейшем иметь не буду, при условии соблюдения Бухта требований законодательства Республики Казахстан и (или) достигнутых в настоящем согласии условий.",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "Текст настоящего согласия мной прочитан, дополнений, замечаний и возражений по нему не имею.",
        className: "paragraph text-black-landing mt-4"
      })
    ],
    className: "flex m-auto flex-col py-10 lg:py-30 px-6 sm:px-48 lg:px-0 lg:w-252"
  });
}

const make = LegalConsentPage;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
